<div class="full-height layout-column">

  <!--Table-->
  <div class="flex layout-column bringoz-table"
       [hidden]="!reports.length">

    <!--Table Headers-->
    <div id="header" class="tr layout-row layout-align-start-center">

      <div class="th flex text-ellipsis text-center" translate>
        Project Name
      </div>

      <div class="flex layout-row layout-align-start-center th text-ellipsis" translate>
        Template Name
      </div>

      <div class="th text-ellipsis flex" translate>Status</div>

      <div class="flex layout-row layout-align-start-center th text-ellipsis" translate>
        From
      </div>

      <div class="flex th text-ellipsis" translate>To</div>

    </div>

    <!--Table Body-->
    <div class="flex layout-column rows-container full-height">

      <!--Repeater-->
      <div class="full-height flex layout-column">
        <cdk-virtual-scroll-viewport [itemSize]="60" class="flex viewport">

          <app-planning-reports-table-row *cdkVirtualFor="let report of reports"
                                          class="item"
                                          [report]="report">

          </app-planning-reports-table-row>

        </cdk-virtual-scroll-viewport>
      </div>
    </div>

  </div>

  <!--Empty State-->
  <div *ngIf="!reports.length"
       class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
    <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                     text="No Reports Found">

    </app-empty-state>
  </div>

</div>
